/**
 * Purchasing today (TASK-0250, FR-TODAY): one read the Today screen and the
 * order guide board share. The server caches it for a minute, so the console
 * polls once a minute too; a refusal or a 503 is not retried automatically
 * (the rows are simply left out, never shown as zero).
 *
 * The key sits under the order guide's (`['purchase-orders', 'guide', …]`), so
 * every PO invalidation (receive, record an invoice, Send) and every guide one
 * (answering a "deliveries look missing" flag) refreshes it at once; dismissing
 * an import invalidates it by name.
 */

import { useQuery } from '@tanstack/react-query';
import { ApiError, api } from '@/lib/api/client';
import type { PurchasingToday } from './types';

export const purchasingTodayKeys = {
  all: ['purchase-orders', 'guide', 'today'] as const,
};

export const PURCHASING_TODAY_POLL_MS = 60_000;

function retry(failureCount: number, error: unknown): boolean {
  if (error instanceof ApiError && error.status >= 400) return false;
  return failureCount < 1;
}

export function usePurchasingToday() {
  return useQuery({
    queryKey: purchasingTodayKeys.all,
    queryFn: () => api.get<PurchasingToday>('/purchasing/today'),
    refetchInterval: PURCHASING_TODAY_POLL_MS,
    staleTime: 45_000,
    retry,
  });
}
